import { Label, Modal, Table } from "semantic-ui-react";

interface Commlog {
  PatNum: number;
  CommDateTime: string;
  CommType?: string;
  Note: string;
}

interface Props {
  onClose: () => any;
  patient: any;
  logs: Commlog[];
}

const CommlogHistoryModal = ({ onClose, patient, logs }: Props) => {
  return (
    <Modal onClose={onClose} open={true} size="large" closeIcon={true}>
      <Modal.Header>
        Commlog History - {patient.firstName} {patient.lastName}
        <Label
          className="float-end float-right"
          as="a"
          size="large"
          basic
          color="blue"
        >
          <strong> {patient.practice?.practice}</strong>
        </Label>
      </Modal.Header>
      <Modal.Content scrolling={true}>
        <Table compact={true} striped={true} selectable={true}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell content="Date" />
              <Table.HeaderCell content="Type" />
              <Table.HeaderCell content="Note" />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {(logs ?? []).map((log: Commlog, index: number) => (
              <Table.Row key={index}>
                <Table.Cell content={log.CommDateTime} />
                <Table.Cell content={log.CommType ?? "-"} />
                <Table.Cell content={log.Note} />
              </Table.Row>
            ))}
            {!logs?.length && (
              <Table.Row style={{ textAlign: "center" }}>
                <Table.Cell colSpan="3">
                  <h4>No commlogs found</h4>
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </Modal.Content>
    </Modal>
  );
};

export default CommlogHistoryModal;
